import { render } from "./dealerForm.vue?vue&type=template&id=604398b0&scoped=true"
import script from "./dealerForm.vue?vue&type=script&lang=js"
export * from "./dealerForm.vue?vue&type=script&lang=js"

import "./dealerForm.vue?vue&type=style&index=0&id=604398b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604398b0"]])

export default __exports__